module.exports = __webpack_public_path__ + "static/engineering2-zig-zag1-d17f0a6bbd1dfc1f0ff5b4c48b4b07eb.png";